// extracted by mini-css-extract-plugin
export var lg = "_eq-7";
export var md = "_eq-6";
export var placeholderContainer = "_eq-1";
export var placeholderIcon = "_eq-2";
export var productImage = "_eq-0";
export var sm = "_eq-5";
export var xl = "_eq-8";
export var xs = "_eq-4";
export var xxs = "_eq-3";